import clsx from "clsx";
import React from "react";
import { DetailedListAppointment } from "./detailedListAppointment.tsx";
import { AppointmentsDTO } from "./dto.ts";

interface Props {
    visible: boolean;
    appointment: AppointmentsDTO;
    isLastColumn: boolean;
    mouseY: number;
    mouseX: number;
}

export function AppointmentTooltip({ visible, appointment, isLastColumn, mouseY, mouseX }: Props) {
    return (
        <div
            className={clsx(
                "fixed z-20 bg-white border border-gray-300 rounded shadow p-2 w-52",
                {
                    block: visible,
                    hidden: !visible,
                }
            )}
            style={{
                top: isLastColumn ? mouseY + 15 : mouseY,
                left: isLastColumn ? undefined : mouseX + 15,
            }}
        >
            <DetailedListAppointment appointment={appointment} />
        </div>
    );
}

